module.exports = __webpack_public_path__ + "static/media/bronzeTop2D.3eb4c415.webp";